import { Calendar, Clock, Folder } from "lucide-react";
import moment from "moment";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import CustomPrimaryButton from "../../dentail-indetifcation/components/d-reusable/CustomPrimaryButton";
import { dentalIcons } from "../../dentail-indetifcation/utils-icons/dentalIcons";
import CustomButtonWithIcon from "../../dentail-indetifcation/components/d-reusable/CustomButtonWithIcon";

const fromNow = (dt) =>
  dt ? moment.utc(dt, "YYYY-MM-DD HH:mm:ss").local().fromNow() : "";

const SingleProjectGridItem = ({ item, onEdit, onDelete, onClick }) => {
  const [showDelete, setShowDelete] = useState(false);
  const me = useSelector((s) => s.settings_data.profileSettings_data);
  const createdAt = item?.created_at;
  const updatedAt = item?.updated_at || createdAt;
  const ownerName = item?.owner?.name || "Unknown";
  const isOwner = item?.owner?.id === me?.id;

  const thumbSrc = item?.thumbnail
    ? `${item.thumbnail}?v=${item.updated_at || item.created_at || Date.now()}`
    : dentalIcons.toothPlaceholder;
  return (
    <div
      style={{ boxShadow: "0 4px 20px 0 rgba(0, 0, 0, 0.10)" }}
      className="relative self-stretch p-2 bg-white rounded-[12px] flex flex-col justify-start items-start gap-2 overflow-hidden"
    >
      <div className="h-60 w-full bg-[#F5F7FA] rounded-[8px] overflow-hidden">
        <img
          src={thumbSrc}
          alt={item.title}
          className="h-full w-full object-cover rounded-inherit"
          key={thumbSrc}
        />
      </div>

      <div className="self-stretch flex flex-col justify-start items-start gap-2 px-2">
        {/* Badge */}
        <div className="px-3 py-1 bg-cyan-400/10 rounded-[32px]  inline-flex justify-center items-center gap-1 overflow-hidden">
          <Folder
            className="h-5 w-5 text-[#2563EB]"
            strokeWidth={1.8}
            color="#20C3FF"
          />

          <div className="text-cyan-400 text-sm font-medium">
            #{item.identifier}
          </div>
        </div>

        {/* Title & Date */}
        <div className="self-stretch flex flex-col justify-start items-start gap-1">
          <div className="text-[16px] font-semibold text-[#000000] hover:text-[#20C3FF] transition-colors line-clamp-1 cursor-pointer">
            {item.title}
          </div>

          <div className="inline-flex justify-start items-center gap-2">
            <div className="flex justify-start items-center gap-1.5">
              <img src={dentalIcons.clockIcon} className="h-4 w-4" />
              <div className="text-[#4AA063] text-sm font-medium">
                Updated {fromNow(item?.updated_at)}
              </div>
            </div>
          </div>
        </div>

        {/* Author */}
        <div className="inline-flex justify-start items-center gap-2 my-1">
          <div className="w-8 h-8 bg-[#20C3FF1A] rounded-full flex justify-center items-center">
            <span className="text-[#20C3FF] text-sm font-medium">
              {(item?.owner?.name || "")
                .split(" ")
                .map((s) => s[0])
                .join("")
                .slice(0, 2)
                .toUpperCase()}
            </span>
          </div>
          <div className="flex flex-col justify-center items-start">
            <div className="text-base font-medium">
              <span className="text-[#A2A2A2]">by</span>
              <span className="text-[#757474]">
                {" "}
                {item?.owner?.name || "Unknown"}
              </span>
            </div>
            <div className="text-[#A2A2A2] text-sm font-normal leading-4">
              Created on{" "}
              {moment
                .utc(item?.created_at, "YYYY-MM-DD HH:mm:ss")
                .local()
                .format("MMM D, YYYY")}
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="flex w-full items-center gap-2 mt-2 mb-2">
          {/* Open Button */}
          <div className="flex-1">
            <CustomPrimaryButton
              title="Open"
              isRound
              // icon={dentalIcons.openProjectAnalysisIcon}
              leadingIcon
              onClick={onClick}
              width={"100%"}
            />
          </div>

          {/* Edit Button */}
          <div className="flex-1">
            <CustomButtonWithIcon
              title="Edit"
              isRound
              // icon={dentalIcons.editPencilIcon}
              leadingIcon
              onClick={onEdit}
              color="#000000"
              borderColor="#E3E3E3"
              width={"100%"}
            />
          </div>
          {isOwner && (
            <div className="flex-1">
              <CustomButtonWithIcon
                title="Delete"
                isRound
                // icon={dentalIcons.deleteIcon}
                leadingIcon
                onClick={onDelete}
                color="#DE0A00"
                borderColor="#E3E3E3"
                width={"100%"}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SingleProjectGridItem;
